import InputTitle from "components/Form/InputTitle";
import { Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import InputGroupFieldError from "./InputGroupFieldError";
import { Context } from "components/Form";
import { useContext } from "react";

export const SelectGroupField = ({
  parentName,
  index,
  input,
  labelName = "label",
  valueName = "value",
  rules = { required: <FormattedMessage id="requiredField" /> },
  lg = "6",
  ...reset
}) => {
  const { locale, formatMessage } = useIntl();
  const { register, errors } = useContext(Context);
  if (!input?.options) return "";

  return (
    <Col lg={lg}>
      <div className={`form-group  ${rules?.required ? "required" : ""}`}>
        <InputTitle name={input?.langId ?? input?.name} />

        <select
          className={`form-control form-outline`}
          {...register(`${parentName}.${index}.${input?.name}`, rules)}
          {...reset}
        >
          {input?.placholder ? (
            <option value={""} hidden disabled>
              {formatMessage({ id: input?.placholder })}
            </option>
          ) : (
            ""
          )}
          {input?.options?.map((option) => (
            <option key={option?.[valueName]} value={option?.[valueName]}>
              {option?.[labelName]?.[locale] || option?.[labelName]}
            </option>
          ))}
        </select>
        <InputGroupFieldError
          errors={errors}
          index={index}
          name={parentName}
          input={input}
        />
      </div>
    </Col>
  );
};
